<div id="test" class="fixed-map2" ><div class="position-absolute" id="map_tooltip" data-bs-html="true">
</div></div>
<i class="fa fa-map-marker position-absolute fa-2x" style="top: 50%; left: 50%;" id="myDiv"></i>
<button class="btn btn-info position-absolute" style="bottom: 0;" (click)="setLocation()">ثبت لوکیشن</button>